import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Box,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material/";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import "./../genericModels.css";
import { DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useFormik } from "formik";
import * as Yup from "yup";

export const AddEditModalMaintenanceCar = (props: any) => {
  const openAddDialog = props.openAddDialog;
  const setOpenAddDialog = props.setOpenAddDialog;
  const createEditMaintenanceCar = props.createEditMaintenanceCar;
  const maintenance = props.maintenance;
  const setMaintenance = props.setMaintenance;
  const pageState = props.pageState;

  const { t } = useTranslation(["operation"]);

  const closeAddMaintenanceModal = () => {
    setMaintenance({
      kmMaintenance: "",

      maintenanceDate: null,
    });
    setOpenAddDialog(false);
  };

  let validateForm = {
    kmMaintenance: Yup.number()
      .required(t("carMaintenance.createAndEdit.validateForm.requiredKM"))
      .typeError(t("carMaintenance.createAndEdit.validateForm.kmTypeError")),
    maintenanceDate: Yup.date()
      .required(t("carMaintenance.createAndEdit.validateForm.requiredDate"))
      .typeError(t("carMaintenance.createAndEdit.validateForm.requiredDate")),
  };

  if (pageState.length > 0 && !maintenance.editId) {
    validateForm = {
      kmMaintenance: Yup.number()
        .required(t("carMaintenance.createAndEdit.validateForm.requiredKM"))
        .typeError(t("carMaintenance.createAndEdit.validateForm.kmTypeError"))
        .min(
          pageState[0].kmMaintenance + 1,
          t("carMaintenance.createAndEdit.validateForm.greaterKM")
        ),

      maintenanceDate: Yup.date()
        .required(t("carMaintenance.createAndEdit.validateForm.requiredDate"))
        .typeError(t("carMaintenance.createAndEdit.validateForm.requiredDate"))
        .test(
          "DOB",
          t("carMaintenance.createAndEdit.validateForm.greaterDate"),
          (maintenanceDate) => {
            return (
              dayjs(pageState[0].maintenanceDate).diff(dayjs(maintenanceDate)) <
              0
            );
          }
        ),
    };
  } else if (pageState.length > 1 && maintenance.editId) {
    validateForm = {
      kmMaintenance: Yup.number()
        .required(t("carMaintenance.createAndEdit.validateForm.requiredKM"))
        .typeError(t("carMaintenance.createAndEdit.validateForm.kmTypeError"))
        .min(
          pageState[1].kmMaintenance + 1,
          t("carMaintenance.createAndEdit.validateForm.greaterKM")
        ),

      maintenanceDate: Yup.date()
        .required(t("carMaintenance.createAndEdit.validateForm.requiredDate"))
        .typeError(t("carMaintenance.createAndEdit.validateForm.requiredDate"))
        .test(
          "DOB",
          t("carMaintenance.createAndEdit.validateForm.greaterDate"),
          (maintenanceDate) => {
            return (
              dayjs(pageState[1].maintenanceDate).diff(dayjs(maintenanceDate)) <
              0
            );
          }
        ),
    };
  }

  const ValidateForm = Yup.object().shape(validateForm);

  const formik = useFormik({
    initialValues: {
      kmMaintenance: `${maintenance.kmMaintenance}`,
      maintenanceDate: `${maintenance.maintenanceDate}`,
      editId: maintenance.editId ? `${maintenance.editId}` : "",
    },

    validationSchema: ValidateForm,
    onSubmit: (values) => {
      createEditMaintenanceCar(values);
      setOpenAddDialog(false);
    },
  });

  return (
    <form id="submit1" onSubmit={formik.handleSubmit}>
      <Box sx={{ padding: 20 }}>
        <Dialog
          fullWidth={true}
          PaperProps={{
            sx: {
              maxWidth: "884px !important",
              minHeight: "253px",
              borderRadius: "4px",
            },
          }}
          open={openAddDialog}
        >
          <DialogTitle>
            <Grid
              container
              alignItems="center"
              alignContent="center"
              direction="row"
            >
              {!maintenance.editId ? (
                <Grid xs item className="createEditModal">
                  {t("carMaintenance.createAndEdit.newMaintenance")}
                </Grid>
              ) : (
                <Grid xs item className="createEditModal">
                  {t("carMaintenance.createAndEdit.editMaintenance")}
                </Grid>
              )}
              <Grid
                xs
                item
                sx={{ justifyContent: "flex-end", display: "flex" }}
              >
                <CloseIcon
                  color="disabled"
                  fontSize="small"
                  onClick={closeAddMaintenanceModal}
                />
              </Grid>
            </Grid>
          </DialogTitle>

          <DialogContent
            sx={{ borderTop: "1px groove rgba(208, 208, 206, 1)" }}
          >
            <Grid container spacing={2.5} paddingTop={3.5} direction="row">
              <Grid xs item>
                <Box>
                  <>
                    {/* <InputLabel
                      style={{
                        fontWeight: 400,
                        fontSize: "14px",
                        lineHeight: "12px",
                      }}
                    >
                      {t("carMaintenance.maintenanceDate")}
                    </InputLabel> */}

                    <DateTimePicker
                      onChange={(e: any) => {
                        formik.setFieldValue(
                          "maintenanceDate",
                          dayjs.utc(e).format("YYYY-MM-DDTHH:mm:ssZ")
                        );
                      }}
                      mask={"__/__/____ __:__"}
                      inputFormat={"DD/MM/YYYY HH:mm"}
                      disableFuture
                      label={t("carMaintenance.maintenanceDate")}
                      ampm={false}
                      value={formik.values.maintenanceDate}
                      renderInput={(params) => (
                        <>
                          <TextField
                            variant="standard"
                           
                            fullWidth
                            {...params}
                            inputProps={{
                              ...params.inputProps,
                             // placeholder: t("carMaintenance.createAndEdit.dateInput"),
                            }}
                            name="maintenanceDate"
                            onBlur={formik.handleBlur}
                            error={
                              formik.values.editId ?
                              Boolean(formik.errors.maintenanceDate) :
                              (formik.touched.maintenanceDate && Boolean(formik.errors.maintenanceDate))
                            }
                            helperText={
                              
                              formik.values.editId ?
                              formik.errors.maintenanceDate :
                              formik.touched.maintenanceDate && formik.errors.maintenanceDate 
                            }
                          />
                        </>
                      )}
                    />
                  </>
                </Box>
              </Grid>
              <Grid xs item>
                <Box>
                  {/* <InputLabel
                    style={{
                      fontWeight: 400,
                      fontSize: "14px",
                      lineHeight: "12px",
                    }}
                  >
                    {t("carMaintenance.maintenanceKM")}
                  </InputLabel> */}
                  <TextField
                    fullWidth
                    id="kmMaintenance"
                    name="kmMaintenance"
                    type="text"
                    label={t("carMaintenance.maintenanceKM")}
                    //placeholder={t("carMaintenance.createAndEdit.kmLabel")}
                    value={formik.values.kmMaintenance}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      
                      formik.values.editId ?
                              Boolean(formik.errors.kmMaintenance) :
                              (Boolean(formik.errors.kmMaintenance) && formik.touched.kmMaintenance)
                    }
                    helperText={
                      formik.values.editId ?
                              formik.errors.kmMaintenance :
                              (formik.touched.kmMaintenance && formik.errors.kmMaintenance )
                  
                      
                    }
                  />
                </Box>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions style={{ background: "#F8F8F8" }}>
            <Stack direction="row" spacing={2.875} p={1} mr={3.625}>
              <Button
                variant="outlined"
                size="medium"
                onClick={closeAddMaintenanceModal}
              >
                <Typography
                  sx={{
                    textTransform: "capitalize",
                    fontWeight: 700,
                    lineHeight: 2.25,
                    color: "#C8017D",
                  }}
                  variant="subtitle1"
                >
                  {t("actionButtons.cancel")}
                </Typography>
              </Button>
              <Button
                form="submit1"
                variant="contained"
                size="medium"
                type={"submit"}
                color="accent"
              >
                <Typography
                  sx={{
                    textTransform: "capitalize",
                    fontWeight: 700,
                    lineHeight: 2.25,
                    color: "white",
                  }}
                  variant="subtitle1"
                >
                  {t("actionButtons.save")}
                </Typography>
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>
      </Box>
    </form>
  );
};
